/*
 * LaFlore: scroll-aware header
 * Ported from the approved ldv2 homepage (workspace .../laflore-design-v2/home.html).
 * Toggles `.lf-header--scrolled` on Horizon's #header-component when the hero
 * sentinel leaves the viewport (GLOB-01, DEC-003: merge & restyle, not replace).
 * Dependency-free, no ES module imports. Requires BOTH #header-component and
 * #hero-sentinel to be present before doing anything -- on every template
 * without a hero (i.e. everything except the homepage) this no-ops entirely,
 * leaving the header in its default teal state from assets/laflore-header.css,
 * with no template-name detection anywhere.
 */
(function () {
  var nav = document.getElementById('header-component');
  var sentinel = document.getElementById('hero-sentinel');
  if (!nav || !sentinel) return;
  // Scroll-state tracking. NOT IntersectionObserver: Horizon's desktop
  // "squeeze" layout scrolls .page-wrapper (document scrolls only on mobile),
  // and a fast wheel/programmatic jump can teleport the sentinel across the
  // viewport without ever intersecting it, so IO never fires and the header
  // sticks in the wrong state. A capture-phase document scroll listener hears
  // scrolls from ANY container; rAF-throttled getBoundingClientRect is cheap.
  var ticking = false;
  function update() {
    ticking = false;
    nav.classList.toggle('lf-header--scrolled', sentinel.getBoundingClientRect().top < 0);
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
